import { NextPage } from "next"
import { FactoringCsv } from "src/features/factoring-csv/components/FactoringCsv"
import Head from "next/head"
import { Heading } from "@smooth/design-system-components"
import { DefaultLayout } from "src/components/Layout"

const FactoringCsvPage: NextPage = () => (
  <DefaultLayout>
    <Head>
      <title>GANB CSVアップロード | for Smoother</title>
    </Head>
    <div style={{ height: "calc(100vh - 90px)", overflowY: "auto" }}>
      <div data-smooth-ds className="mx-auto max-w-[900px] px-4 py-6 sm:px-6 lg:px-8">
        <div className="mb-6 flex flex-col gap-2">
          <Heading level={1}>GANB CSVアップロード</Heading>
        </div>
        <FactoringCsv />
      </div>
    </div>
  </DefaultLayout>
)

export default FactoringCsvPage
